/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Frontend SPA Contract API
 * Canonical API contract entrypoint.
 *
 * Source architecture:
 * - split by module / bounded context
 * - one file per aggregate root
 * - child entities remain owned by aggregate root
 * - cross-cutting technical concerns live under `openapi/common`
 *
 * OpenAPI spec version: 1.0.0
 */
import * as zod from "zod";

import {NoteId, NoteInput} from "../__ignore/schemas";

/**
 * @summary Edit client note
 */
export const EditClientNoteBody = NoteInput;

export const EditClientNoteResponse = zod.void();

/**
 * @summary Remove client note
 */
export const RemoveClientNoteResponse = zod.void();

/**
 * @summary Add client note
 */
export const AddClientNoteBody = NoteInput;

export const AddClientNoteResponse = NoteId;
